// extracted by mini-css-extract-plugin
export default {"spintacular":"spinner_spintacular__QoRPE","svg-animation":"spinner_svg-animation__c3wP2","circle-animation":"spinner_circle-animation__10U-L"};